"use client"

import React, { useState, useEffect } from "react";
import Image from "next/image";

const Gallerymodal = ({ galleryImages, currentIndex, setClickedImage }) => {
    const [currentImageIndex, setCurrentImageIndex] = useState(currentIndex);
    const [clickedImage, setClickedImageLocal] = useState(galleryImages[currentIndex].bgImage || galleryImages[currentIndex].video);

    useEffect(() => {
        setClickedImageLocal(galleryImages[currentImageIndex].bgImage || galleryImages[currentImageIndex].video);
    }, [currentImageIndex, galleryImages]);

    const handleRotationRight = () => {
        const totalLength = galleryImages.length;
        if (currentImageIndex + 1 >= totalLength) {
            setCurrentImageIndex(0);
            return;
        }
        setCurrentImageIndex(currentImageIndex + 1);
    };

    const handleRotationLeft = () => {
        const totalLength = galleryImages.length;
        if (currentImageIndex === 0) {
            setCurrentImageIndex(totalLength - 1);
            return;
        }
        setCurrentImageIndex(currentImageIndex - 1);
    };

    const handleClick = (e) => {
        if (e.target.classList.contains("dismiss")) {
            setClickedImage(null);
        }
    };

    const currentItem = galleryImages[currentImageIndex];

    return (
        <>
            <div className="modal_overlay dismiss" onClick={handleClick}>
                {currentItem.bgImage ? (
                    <img className="modal_image" src={clickedImage} alt="bigger picture" />
                ) : (
                    <video className="modal_video" controls>
                        <source src={clickedImage} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                )}
                <span className="dismiss close_icon" onClick={handleClick}>
                    <Image src='/icons/close-white.svg' className="dismiss" width={20} height={20} alt='Close arrow icon' />
                </span>
                <div onClick={handleRotationLeft} className="overlay-arrows_left">
                    <Image src='/icons/left-white.svg' width={30} height={30} alt='Left Icon' />
                </div>
                <div onClick={handleRotationRight} className="overlay-arrows_right">
                    <Image src='/icons/right-white.svg' width={30} height={30} alt='Right Icon' />
                </div>
            </div>
        </>
    );
};

export default Gallerymodal;
